/* EmmetiStore product header 1.0.0. ASCII source, no dependencies. */
(function () {
  'use strict';
  if (customElements.get('emmeti-product-header')) return;
  class EmmetiProductHeader extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.init()); }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const details = this.querySelector('[data-eph-level]');
      const trigger = details && details.querySelector('summary');
      const guide = this.querySelector('[data-eph-guide]');
      if (trigger && guide && typeof HTMLDialogElement !== 'undefined' && HTMLDialogElement.prototype.showModal) {
        let dialog = this.querySelector('dialog');
        if (!dialog) {
          dialog = document.createElement('dialog');
          dialog.className = 'eph__dialog';
          dialog.setAttribute('aria-labelledby', guide.querySelector('h2').id);
          dialog.append(guide);
          this.append(dialog);
        }
        this.dialog = dialog;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        const close = guide.querySelector('[data-eph-close]');
        close.hidden = false;
        trigger.addEventListener('click', event => {
          event.preventDefault();
          if (dialog.open) return;
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
          // Start the guide at its heading, including after reopening on mobile.
          dialog.scrollTop = 0;
          close.focus({preventScroll: true});
        }, options);
        close.addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...dialog.querySelectorAll('button,a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && el.getClientRects().length);
          const first = items[0], last = items[items.length - 1];
          if (!first) return;
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          if (trigger.isConnected) trigger.focus({preventScroll: true});
        }, options);
      }
      const reviews = this.querySelector('[data-eph-reviews]');
      if (reviews) reviews.addEventListener('click', event => {
        const id = reviews.getAttribute('href').slice(1);
        const target = document.getElementById(id) || document.getElementById('ReviewsWidget') || document.getElementById('shopify-product-reviews');
        if (!target) return;
        event.preventDefault();
        const ancestors = [];
        for (let node = target; node; node = node.parentElement) ancestors.unshift(node);
        ancestors.forEach(node => {
          if (node.tagName === 'DETAILS' && !node.open) {
            const disclosure = node.parentElement;
            if (disclosure.tagName === 'DETAILS-DISCLOSURE' && typeof disclosure.open === 'function') disclosure.open();
            else node.open = true;
          }
          if (node.getAttribute('role') === 'tabpanel' && node.hidden) {
            const tabs = node.closest('tabbed-content');
            const tab = tabs && [...tabs.querySelectorAll('[role="tab"]')].find(item => item.getAttribute('aria-controls') === node.id);
            if (tab) tab.click();
          }
        });
        requestAnimationFrame(() => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end-padded')) || 100;
          window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset - 16), behavior: reduced ? 'auto' : 'smooth'});
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({preventScroll: true});
        });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  }
  customElements.define('emmeti-product-header', EmmetiProductHeader);
})();
